<template>
  <div>
    <filter-bar
      name="reports"
      :filter="_getReportsFilter"
      v-if="!showMobileView"
      :searchTypes="searchTypes"
    />
    <div>
      <v-tabs
        center-active
        :class="tabClass"
        color="black"
        :height="tabHeight"
        v-model="tab"
        style="background: #EFEFEF"
      >
        <div
          class="d-flex justify-space-between"
          style="width:100%; background: #EFEFEF;"
          v-if="showMobileView"
        >
          <v-tab class="text-capitalize">
            Rentals
          </v-tab>
          <v-tab class="text-capitalize">
            Charged Off
          </v-tab>
          <v-tab class="text-capitalize">
            Utilization
          </v-tab>
          <v-tab class="text-capitalize">
            Advertisements
          </v-tab>
        </div>
        <div
          class="d-flex justify-space-between align-end mb-3 flex-column"
          style="width:100%; height:100%;"
          v-if="!showMobileView"
        >
          <div class="d-flex justify-center" style="width:100%;">
            <div
              class="d-flex justify-center"
              v-if="!showMobileView"
              style="height:50px; width:100%;"
            >
              <v-tab class="text-capitalize" id="reports-rentals-tab">
                Rentals
              </v-tab>
              <v-tab class="text-capitalize" id="reports-charged-tab">
                Charged Off
              </v-tab>
              <v-tab class="text-capitalize" id="reports-utilization-tab">
                Utilization
              </v-tab>
              <v-tab class="text-capitalize" id="reports-advertisemens-tab">
                Advertisements
              </v-tab>
            </div>
            <div class="d-flex align-end mt-4">
              <v-card
                class="mr-4 mt-4 mb-1 d-flex align-center"
                height="40"
                width="148"
                color="secondary"
                v-if="!showMobileView"
                style="color:white; font-weight:bold; position:absolute; right:0;"
                @click="setDownload()"
              >
                <v-row>
                  <v-spacer />
                  <v-spacer />
                  <v-row
                    class="d-flex justify-space-around"
                    id="reports-export-button"
                  >
                    <v-icon color="white">mdi-download</v-icon>
                    Export Report
                  </v-row>
                  <v-spacer />
                  <v-spacer />
                </v-row>
              </v-card>
            </div>
          </div>
        </div>
        <!-- Rentals -->
        <v-tab-item style="background: #EFEFEF" :class="tabAdjust">
          <div class="d-flex mb-n6 justify-space-between" v-if="showMobileView">
            <search class="ml-3" />
            <v-card
              class="mr-4 mt-6 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn
              style="width: calc(100vw - 32px)"
              @click="setDownload"
              color="secondary"
              height="44"
            >
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div>
          <chart
            v-if="showMobileView"
            type="radial-bar"
            :data="[
              getPercentage(_chartData.rentalData.data[0], _getSessions),
              getPercentage(_chartData.rentalData.data[1], _getSessions)
            ]"
            :labels="_chartData.rentalData.labels"
            title="Rental Data"
            width="auto"
            :total="
              _chartData.rentalData.data[0] + _chartData.rentalData.data[1]
            "
          />
          <v-card
            class="d-flex mt-5 transparent"
            v-if="!showMobileView"
            style="max-width:100%;"
            flat
          >
            <chart
              type="radial-bar"
              :data="[getPercentage(splitReportChart.oneWay, _getSessions)]"
              :labels="[oneWayTerm]"
              :title="oneWayTerm"
              :id="
                'reports-chart-' +
                  oneWayTerm
                    .toLowerCase()
                    .split(' ')
                    .join('-')
              "
              width="100%"
            />
            <chart
              type="radial-bar"
              :data="[getPercentage(splitReportChart.roundTrip, _getSessions)]"
              :labels="[roundTripTerm]"
              :options="{ colors: ['#000000'] }"
              :title="roundTripTerm"
              :id="
                'reports-chart-' +
                  roundTripTerm
                    .toLowerCase()
                    .split(' ')
                    .join('-')
              "
              width="100%"
            />
            <!-- <chart
              type="pie"
              v-if="
                _client.uuid &&
                _client.uuid === '66993187-282c-4932-a7c0-153eb0b253a2'
              "
              :data="_chartData.liteVsFull.data"
              :labels="['Full', 'Lite']"
              :options="{ colors: ['#4d3bed', '#00ff33'] }"
              title="Lite Vs Full Rental"
              width="100%"
            /> -->
          </v-card>
          <rentals-table class="mt-6" />
        </v-tab-item>
        <!-- Charged Off -->
        <v-tab-item style="background: #EFEFEF" :class="tabAdjust">
          <div class="d-flex mb-n6 justify-space-between" v-if="showMobileView">
            <search class="ml-3" />
            <v-card
              class="mr-4 mt-6 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn
              style="width: calc(100vw - 32px)"
              @click="setDownload"
              color="secondary"
              height="44"
            >
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div>
          <chart
            v-if="showMobileView"
            type="radial-bar"
            :data="[
              getPercentage(
                _chartData.chargedOffRentalData.data[0],
                _getChargedOffSessions
              ),
              getPercentage(
                _chartData.chargedOffRentalData.data[1],
                _getChargedOffSessions
              )
            ]"
            :labels="_chartData.chargedOffRentalData.labels"
            title="Charged Off"
            width="auto"
            :total="
              _chartData.chargedOffRentalData.data[0] +
                _chartData.chargedOffRentalData.data[1]
            "
          />
          <v-card
            v-if="!showMobileView"
            class="d-flex justify-space-around mt-6 transparent"
            style="max-width:100%;"
            flat
          >
            <chart
              type="radial-bar"
              :data="[
                getPercentage(
                  _chartData.chargedOffRentalData.data[0],
                  _getChargedOffSessions
                )
              ]"
              width="100%"
              :labels="[oneWayTerm]"
              :title="oneWayTerm"
            />
            <chart
              type="radial-bar"
              :data="[
                getPercentage(
                  _chartData.chargedOffRentalData.data[1],
                  _getChargedOffSessions
                )
              ]"
              width="100%"
              :labels="[roundTripTerm]"
              :options="{ colors: ['#000000'] }"
              :title="roundTripTerm"
            />
          </v-card>
          <charged-off-table class="mt-6" />
        </v-tab-item>
        <!-- Inventory
        <v-tab-item :class="tabAdjust">
          <div class="d-flex mb-n6" v-if="showMobileView">
            <search />
            <v-card
              class="mr-4 mt-4 d-flex align-center flex-shrink-0"
              height="48"
              width="48"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn style="width: calc(100vw - 32px)" color="secondary" height="44">
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div>
          <chart
            type="pie"
            :data="_chartData.deviceOverview.data"
            :labels="_chartData.deviceOverview.labels"
            title="Device Overview"
            :options="{
              colors: ['#3887B7', '#ADADAD']
            }"
          >
            <template v-slot:default>
              <div>
                <v-card-text class="text-h5 font-weight-medium black--text">
                  Device Overview
                </v-card-text>
                <v-card-text
                  class="py-0 text-subtitle-2 font-weight-medium black--text"
                >
                  Total Devices
                </v-card-text>
                <v-card-text class="py-0 text-h6 font-weight-medium black--text">
                  {{ totalDevices }}
                </v-card-text>
              </div>
            </template>
            <template v-slot:bottom>
              <div class="d-flex">
                <v-spacer />
                <v-card
                  color="primary"
                  class="ma-6 rounded-sm elevation-0"
                  width="140"
                >
                  <v-card-text
                    class="
                    white--text
                    text-subtitle-1
                    font-weight-medium
                    py-0
                    text-center
                  "
                  >
                    6 OVERDUE
                  </v-card-text>
                </v-card>
              </div>
            </template>
          </chart>
          <chart
            type="radial-bar"
            :data="_chartData.rentalData.data"
            :labels="_chartData.rentalData.labels"
            title="1-WAY TRIP VS ROUND TRIPS"
          />
        </v-tab-item> -->
        <!-- Utilization -->
        <v-tab-item style="background: #EFEFEF" :class="tabAdjust">
          <div class="d-flex mb-n6 justify-space-between" v-if="showMobileView">
            <search class="ml-3" />
            <v-card
              class="mr-4 mt-6 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn
              style="width: calc(100vw - 32px)"
              color="secondary"
              height="44"
              @click="setDownload"
            >
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div>
          <div class="d-flex flex-wrap justify-center">
            <chart
              :style="topChartWidth"
              type="line-chart"
              id="device-util-chart"
              :data="_chartData.deviceUtilization.data"
              :labels="_chartData.deviceUtilization.labels"
              title="Device Utilization"
              :options="{
                colors: ['#0FF188'],
                ymax: 100,
                ymin: 0
              }"
            >
              <v-card-text
                class="text-body-1 font-weight-medium black--text pb-0"
              >
                Device Utilization
              </v-card-text>
              <v-card-text class="text-h5 font-weight-medium black--text pt-0">
                {{ deviceUtilization }}
              </v-card-text>
            </chart>
            <chart
              :style="topChartWidth"
              type="bar-chart"
              id="unique-rentals-bar-chart"
              :data="_chartData.rentalsByWeek.data"
              :labels="_chartData.rentalsByWeek.labels"
              :options="{
                colors: [
                  '#0CFB92',
                  '#000000',
                  '#0F84F1',
                  '#D4002A',
                  '#777777',
                  '#87001B',
                  '#FFC100'
                ],
                ytitle: 'Number of Rentals'
              }"
              title="Average Unique Rentals by Day of Week"
            />
            <chart
              type="bar-chart"
              :style="topChartWidth"
              id="unique-rentals-hour-bar-chart"
              :data="_chartData.rentalsByDay.data"
              :labels="_chartData.rentalsByDay.labels"
              :options="{
                colors: ['#3887B7'],
                ytitle: 'Number of Rentals'
              }"
              title="Average Unique Rentals by Hour of Day"
            />
          </div>
          <div :class="showMobileView ? '' : 'd-flex justify-center'">
            <chart
              type="pie"
              id="screens-status-chart"
              :style="bottomChartWidth"
              :data="_chartData.checkedIn.data"
              :labels="['Checked Out', 'Checked In']"
              :secondaryTitle="screenTotal"
              :overdue="_chartData.checkedIn.overdue"
              :options="{ colors: ['#3887B7', '#777777'] }"
              title="Screens Status"
            />
            <chart
              v-if="showMobileView"
              type="radial-bar"
              :data="[
                getPercentage(_chartData.rentalData.data[0], _getSessions),
                getPercentage(_chartData.rentalData.data[1], _getSessions)
              ]"
              :labels="_chartData.rentalData.labels"
              title="Rental Data"
              width="auto"
              :total="
                _chartData.rentalData.data[0] + _chartData.rentalData.data[1]
              "
            />
            <v-card
              class="d-flex ma-3 flex-column"
              v-if="!showMobileView"
              :style="bottomChartWidth"
            >
              <v-card-title>{{ graphTitle }}</v-card-title>
              <div class="d-flex">
                <chart
                  type="radial-bar"
                  :data="[getPercentage(splitReportChart.oneWay, _getSessions)]"
                  :labels="[oneWayTerm]"
                  :title="oneWayTerm"
                  :id="
                    oneWayTerm
                      .toLowerCase()
                      .split(' ')
                      .join('-') + '-chart'
                  "
                  width="100%"
                  height="90%"
                  elevation="0"
                />
                <chart
                  type="radial-bar"
                  :data="[
                    getPercentage(splitReportChart.roundTrip, _getSessions)
                  ]"
                  :labels="[roundTripTerm]"
                  :options="{ colors: ['#000000'] }"
                  :title="roundTripTerm"
                  width="100%"
                  :id="
                    roundTripTerm
                      .toLowerCase()
                      .split(' ')
                      .join('-') + '-chart'
                  "
                  height="90%"
                  elevation="0"
                />
              </div>
            </v-card>
          </div>
          <utilization-table v-if="!showMobileView" />
        </v-tab-item>
        <!-- Advertisements -->
        <v-tab-item style="background: #EFEFEF" :class="tabAdjust">
          <!-- <div class="d-flex mb-n6" v-if="showMobileView">
            <search />
            <v-card
              class="mr-4 mt-4 d-flex align-center flex-shrink-0"
              height="40"
              width="40"
              color="black"
              @click="_setFilter(true)"
            >
              <v-row>
                <v-spacer />
                <v-col>
                  <v-icon color="white">mdi-filter</v-icon>
                </v-col>
                <v-spacer />
              </v-row>
            </v-card>
          </div>
          <div class="d-flex justify-center pt-5" v-if="showMobileView">
            <v-btn style="width: calc(100vw - 32px)" color="secondary" height="44">
              <v-icon>mdi-download</v-icon>
              Export Report
            </v-btn>
          </div> -->
          <v-card class="ma-4 d-flex justify-center" height="400">
            <v-card-title class="pa-0">
              <v-card-text class="text-h6 font-weight-medium">
                Coming Soon
              </v-card-text>
            </v-card-title>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
    <filters />
    <rental-details />
    <export-report :tab="tab" />
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import Search from '@/components/app/Search';
import Chart from '@/components/charts/Chart';
import Filters from '@/components/filter/Filters';
import ChargedOffTable from '@/components/reports/ChargedOffTable';
import RentalsTable from '@/components/reports/RentalsTable';
import UtilizationTable from '@/components/reports/UtilizationTable';
import FilterBar from '@/components/app/FilterBar.vue';
import ExportReport from '@/components/reports/ExportReport';
import { MobileView } from '@/mixins';
import RentalDetails from '@/components/reports/RentalDetails';

export default {
  components: {
    Search,
    Filters,
    Chart,
    ChargedOffTable,
    RentalsTable,
    UtilizationTable,
    FilterBar,
    ExportReport,
    RentalDetails,
  },
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      _chartData: 'reports/getChartData',
      _getReportsFilter: 'filters/getFilter',
      _getExport: 'reports/getExport',
      _getTab: 'reports/getTab',
      _client: 'account/getCurrentClient',
      _getSessions: 'reports/getSessions',
      _getChargedOffSessions: 'reports/getChargedOffSessions',
    }),
    tab: {
      get() {
        return this._getTab;
      },
      set(val) {
        this._setTab(val);
      },
    },
    deviceUtilization() {
      if (this._chartData.deviceUtilization.data[0].data.length > 0) {
        let total = 0;
        this._chartData.deviceUtilization.data[0].data.map((point) => {
          total += point;
        });
        total = Math.round(
          total / this._chartData.deviceUtilization.data[0].data.length,
        );
        return `${total}% Avg`;
      }
      return '';
    },
    searchTypes() {
      if (this.tab === 0) {
        return ['Ad Schedule', 'Phone Number'];
      }
      return ['Phone Number'];
    },
    oneWayTerm() {
      if (this._client.client_name === 'bazzbi') {
        return 'QR Code';
      } if (this._client.client_name === 'shark') {
        return 'Bluetooth';
      }
      return 'One Way';
    },
    roundTripTerm() {
      if (this._client.client_name === 'bazzbi') {
        return 'Digital Key';
      } if (this._client.client_name === 'shark') {
        return 'Premium';
      }
      return 'Round Trip';
    },
    graphTitle() {
      if (this._client.client_name === 'bazzbi') {
        return 'QR Code vs Digital Key';
      } if (this._client.client_name === 'shark') {
        return 'BlueTooth vs Premium';
      }
      return 'One Way Trips vs Round Trips';
    },
    screenTotal() {
      return (
        `${this._chartData.checkedIn.data[0]
        + this._chartData.checkedIn.data[1]
        } total`
      );
    },
    totalDevices() {
      let total = 0;
      for (let i = 0; i < this._chartData.rentalData.data.length; i++) {
        total += this._chartData.rentalData.data[i];
      }
      return total;
    },
    tabHeight() {
      if (this.showMobileView) {
        return '28px';
      }
      return '50px';
    },
    tabClass() {
      if (this.showMobileView) {
        return 'mt-6 ml-n7';
      }
      return '';
    },
    tabAdjust() {
      if (this.showMobileView) {
        return 'ml-7 mr-n7';
      }
      return '';
    },
    topChartWidth() {
      if (this.showMobileView) {
        return 'width:100%;';
      }
      return 'width:calc(33.2% - 24px);';
    },
    bottomChartWidth() {
      if (this.showMobileView) {
        return 'width:100%;';
      }
      return 'width:calc(49.8% - 24px);';
    },
    convertedFilter() {
      const filterArray = [];
      const newFilter = { ...this._getReportsFilter };
      Object.keys(newFilter).map((key) => {
        if (
          this._getReportsFilter.range
          && key !== 'start_date'
          && key !== 'end_date'
        ) {
          const filterObject = { value: this._getReportsFilter[key], name: key };
          filterArray.push(filterObject);
        }
      });
      return filterArray;
    },
    splitReportChart() {
      const dataObj = {};
      dataObj.oneWay = [this._chartData.rentalData.data[0]];
      dataObj.roundTrip = [this._chartData.rentalData.data[1]];
      return dataObj;
    },
  },
  methods: {
    ...mapActions({
      _acquireData: 'reports/acquireGroups',
      _acquireInstances: 'reports/acquireSessions',
    }),
    ...mapMutations({
      _setFilter: 'filters/setFilters',
      setReportsFilter: 'filters/setReportsFilter',
      _setExport: 'reports/setExport',
      _setTab: 'reports/setTab',
    }),
    adjustReportsFilter(item) {
      if (item === 'clear') {
        this.setReportsFilter({ search: '' });
      } else {
        const copiedFilter = { ...this.getReconciliationFilter };
        delete copiedFilter[item.name];
        if (item.name === 'range') {
          delete copiedFilter.start_date;
          delete copiedFilter.end_date;
        }
        this.setReportsFilter(copiedFilter);
      }
    },
    getPercentage(value, sessions) {
      return ((100 * value) / sessions.length).toFixed(1);
    },
    setDownload() {
      this._setExport(true);
    },
  },
  mounted() {
    this._acquireData();
    this._acquireInstances();
  },
  watch: {
    tab() {
      window.dispatchEvent(new Event('resize'));
    },
  },
};
</script>
